import { INPUT_ERRORS } from "utils/form/errors";
import { EMAIL_REGEX, PASSWORD_REGEX } from "utils/form/regex";
import * as yup from "yup";

const emailValidation = yup
  .string()
  .required(INPUT_ERRORS.required)
  .matches(EMAIL_REGEX, INPUT_ERRORS.email);

export const validationSignInSchema = yup.object({
  email: emailValidation,
  password: yup
    .string()
    .min(6, "La contraseña debe contener al menos 6 caracteres")
    .max(40, "La contraseña debe contener como máximo 40 caracteres")
    .matches(PASSWORD_REGEX, INPUT_ERRORS.password)
    .required(INPUT_ERRORS.required),
});

export const validationUploadPasswordSchema = yup.object({
  newPassword: yup
    .string()
    .min(6, "La contraseña debe contener al menos 6 caracteres")
    .max(40, "La contraseña debe contener como máximo 40 caracteres")
    .matches(PASSWORD_REGEX, INPUT_ERRORS.password)
    .required(INPUT_ERRORS.required),
  repeatPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "Las contraseñas no coinciden")
    .required(INPUT_ERRORS.required),
});

export const validationResetPasswordSchema = yup.object({
  email: emailValidation,
});
